import type { CustomInnerHeaderProps } from "ag-grid-react";
import styled from "styled-components";

export type BackendSortDirection = "asc" | "desc";

export type BackendSortHeaderParams<SortKey extends string = string> = {
  sortKey: SortKey;
  activeSortBy?: SortKey;
  activeSortDirection?: BackendSortDirection;
  onSortChange: (sortKey: SortKey) => void;
};

type Props = CustomInnerHeaderProps & BackendSortHeaderParams;

const SortButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  border: 0;
  padding: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
  text-align: left;
`;

const SortIndicator = styled.span`
  font-size: 10px;
  font-weight: 700;
`;

const getSortIndicator = (isSorted: boolean, sortDirection: BackendSortDirection | undefined) => {
  if (!isSorted) {
    return "";
  }

  return sortDirection === "asc" ? "ASC" : "DESC";
};

export const BackendSortHeader = ({
  displayName,
  sortKey,
  activeSortBy,
  activeSortDirection,
  onSortChange,
}: Props) => {
  const isSorted = activeSortBy === sortKey && Boolean(activeSortDirection);
  const indicator = getSortIndicator(isSorted, activeSortDirection);

  return (
    <SortButton type="button" tabIndex={-1} onClick={() => onSortChange(sortKey)}>
      <span>{displayName}</span>
      {indicator && <SortIndicator>{indicator}</SortIndicator>}
    </SortButton>
  );
};
